import { useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, Button, FlexGrid } from "@albo-ui/core";
import { Box, TextField } from '@mui/material';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import { useCRMUpdateUuid } from "./hooks/useCRMUpdateUuid";

export type CRMUpdateUuidProps = {
    open: boolean;
    data: Object;
    onClose: () => void;
    onConfirm: (data) => void;
};

export const CRMUpdateUuid = ({ data, open, onClose, onConfirm }: CRMUpdateUuidProps) => {
    const { form, isValid, error, onHandleChange, storeData, getPayload } = useCRMUpdateUuid();
    
    useEffect(() => {
        data && storeData(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    return (
        <Dialog onClose={onClose} open={open} style={{ minWidth: 600, maxHeight: 500 }}>
            {data &&
                <DialogTitle>
                    <Box display={"flex"} alignItems={"center"}>
                        <BusinessCenterIcon sx={{ marginRight: 2 }} color="primary" fontSize="large"/>
                        <Typography variant="h2" style={{ fontSize: "1.2rem" }}>{data["general"]["company_name"]}</Typography>
                    </Box>
                </DialogTitle>
            }
            <DialogContent>
                <FlexGrid style={{marginBottom: 10}}>
                    <Box mb={2}><Typography variant="paragraph">A continuación complete el campo con el UUID correspondiente:</Typography></Box>
                    <TextField value={(form && form["reference_uuid"]) || ""} onInput={onHandleChange.bind(this, "reference_uuid" )} color="secondary" label={"Onboarding UUID"} fullWidth/>
                    <Box mt={2}><TextField value={(form && form["customer_uuid"]) || ""} onInput={onHandleChange.bind(this, "customer_uuid")} color="secondary" label={"Customer UUID"} fullWidth/></Box>
                </FlexGrid>
                {error && <Typography variant="small" color="required" style={{marginTop: 50}}>{error}</Typography>}
            </DialogContent>

            <DialogActions>
                <FlexGrid container fullHeight fullWidth justify="space-between" alignItems="flex-end" style={{ marginTop: 10 }}>
                    <FlexGrid item>
                        <Button onClick={onClose} buttonType="secondary" size="normal">Cancelar</Button>
                    </FlexGrid>
                    <FlexGrid item>
                        <Button onClick={onConfirm.bind(this, getPayload())} disabled={!isValid} size="normal" >Aceptar</Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    );
};
